import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  SupportNumberProps,
  supportNumberStore,
  identity$,
  setSupportNumber,
} from './supportNumber.respository';

@Injectable({
  providedIn: 'root',
})
export class SupportNumberService {
  private store = supportNumberStore;

  public supportNumber$: Observable<SupportNumberProps> = identity$;

  public setSupportNumber(supportNumber: string | undefined): void {
    setSupportNumber(supportNumber);
  }

  public clear(): void {
    this.store.reset();
  }
}
